module.exports = __webpack_public_path__ + "img/remove.a1de2086.svg";